"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationPreferencesResponseSchema = exports.notificationListResponseSchema = exports.notificationPreferenceSchema = exports.notificationSchema = exports.notificationStatusSchema = exports.notificationChannelSchema = exports.notificationPrioritySchema = exports.notificationCategorySchema = void 0;
const zod_1 = require("zod");
exports.notificationCategorySchema = zod_1.z.enum([
    "ALERT",
    "BILLING",
    "DEVICE",
    "FLEET",
    "REPORT",
    "SYSTEM",
    "CUSTOM",
]);
exports.notificationPrioritySchema = zod_1.z.enum([
    "LOW",
    "MEDIUM",
    "HIGH",
    "CRITICAL",
]);
exports.notificationChannelSchema = zod_1.z.enum([
    "EMAIL",
    "SMS",
    "PUSH",
    "WEBHOOK",
    "IN_APP",
]);
exports.notificationStatusSchema = zod_1.z.enum([
    "PENDING",
    "SENT",
    "DELIVERED",
    "FAILED",
    "ACKNOWLEDGED",
]);
exports.notificationSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    userId: zod_1.z.string(),
    category: exports.notificationCategorySchema,
    priority: exports.notificationPrioritySchema,
    channel: exports.notificationChannelSchema.nullish(),
    status: exports.notificationStatusSchema,
    title: zod_1.z.string(),
    message: zod_1.z.string(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable().optional(),
    readAt: zod_1.z.string().datetime().nullable().optional(),
    acknowledgedAt: zod_1.z.string().datetime().nullable().optional(),
    archivedAt: zod_1.z.string().datetime().nullable().optional(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
})
    .strict();
exports.notificationPreferenceSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    organizationId: zod_1.z.string().nullable().optional(),
    userId: zod_1.z.string(),
    channel: exports.notificationChannelSchema,
    preferences: zod_1.z.record(zod_1.z.string(), zod_1.z.boolean()).nullable().optional(),
    mutedUntil: zod_1.z.string().datetime().nullable().optional(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
})
    .strict();
exports.notificationListResponseSchema = zod_1.z.object({
    notifications: zod_1.z.array(exports.notificationSchema),
    total: zod_1.z.number(),
    unread: zod_1.z.number(),
    hasMore: zod_1.z.boolean(),
    limit: zod_1.z.number().optional(),
    offset: zod_1.z.number().optional(),
});
exports.notificationPreferencesResponseSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.record(zod_1.z.string(), zod_1.z.boolean()));
